import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { ArovySubdomainValidationPattern } from './Validation';
import classNames from 'classnames';

import { Button, Form, FormInstance, Input } from 'antd';
import { OidcProviderDeleteButton, OidcProviderHelpArticleLink, OidcProviderSetupProps, OktaIcon } from '.';
import React, { useCallback, useEffect, useRef } from 'react';

export type OktaOidcProviderSetupProps = OidcProviderSetupProps;

export interface OktaOidcConfigurationFormValues {
	oktaDomain?: string;
	clientId?: string;
	subdomain?: string;
}

export const OktaOidcProviderSetup: React.FC<OktaOidcProviderSetupProps> = (props) => {
	const { oidcConfiguration, onCleared, onDeleted, onUpdated, isErrored, isEnteringNewData } = props;

	const formRef = useRef<FormInstance<OktaOidcConfigurationFormValues>>(null);
	const formStyle = classNames('oidc-provider-setup-form',
		'inline-form-with-overhead-labels',
		{ 'oidc-errored-form': isErrored });

	const handleUpdated = useCallback((values: OktaOidcConfigurationFormValues) => {
		if (onUpdated && values.clientId && values.oktaDomain && values.subdomain) {
			onUpdated({
				oidcClientId: values.clientId,
				oidcDomain: values.oktaDomain,
				oidcIssuer: values.oktaDomain,
				provider: 'okta',
				subdomain: values.subdomain
			});
		}
	}, [ onUpdated ]);

	useEffect(() => {
		if (oidcConfiguration) {
			formRef.current?.resetFields();
		}
	}, [ oidcConfiguration ]);

	return (
		<div>
			<OidcProviderHelpArticleLink
				icon={ <OktaIcon /> }
				link={ ADMIN_DASHBOARD_COPY.OKTA_HELP_ARTICLE_LINK }
				text={ ADMIN_DASHBOARD_COPY.OKTA_HELP_ARTICLE } />
			<Form
				className={ formStyle }
				colon={ false }
				initialValues={ {
					clientId: oidcConfiguration?.oidcClientId,
					oktaDomain: oidcConfiguration?.oidcDomain,
					subdomain: oidcConfiguration?.subdomain
				} }
				layout='inline'
				onFinish={ handleUpdated }
				ref={ formRef }>
				<Form.Item
					label={ ADMIN_DASHBOARD_COPY.OKTA_DOMAIN }
					name='oktaDomain'
					rules={ [
						{
							message: ADMIN_DASHBOARD_COPY.OKTA_DOMAIN_REQUIRED,
							required: true
						},
						{
							message: ADMIN_DASHBOARD_COPY.OKTA_DOMAIN_INVALID_FORMAT,
							pattern: /^https:\/\/.+?\.okta\.com$/u
						}
					] }>
					<Input />
				</Form.Item>
				<Form.Item
					label={ ADMIN_DASHBOARD_COPY.OKTA_CLIENT_ID }
					name='clientId'
					rules={ [
						{
							message: ADMIN_DASHBOARD_COPY.OKTA_CLIENT_ID_REQUIRED,
							required: true
						}
					] }>
					<Input />
				</Form.Item>
				<Form.Item
					label={ ADMIN_DASHBOARD_COPY.AROVY_SUBDOMAIN }
					name='subdomain'
					rules={ [
						{
							message: ADMIN_DASHBOARD_COPY.AROVY_SUBDOMAIN_REQUIRED,
							required: true
						},
						{
							message: ADMIN_DASHBOARD_COPY.AROVY_SUBDOMAIN_INVALID_FORMAT,
							pattern: ArovySubdomainValidationPattern
						}
					] }>
					<Input />
				</Form.Item>
				<Button
					htmlType='submit'
					type='primary'>
					{ ADMIN_DASHBOARD_COPY.SUBMIT }
				</Button>
				<OidcProviderDeleteButton
					isEnteringNewData={ isEnteringNewData }
					onCleared={ onCleared }
					onDeleted={ onDeleted } />
			</Form>
		</div>
	);
};

